// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentModel } from '@okcargo-apps/shared-infrastructure';

const API_URL = 'https://shippers.demo.okcargo.io';
const LOCAL_VERSION_URL = 'assets/versions.json';

export const environment: EnvironmentModel = {
  production: true,
  // production: false,

  apiUrl: API_URL,
  apiDemoUrl: 'https://shippers.demo.okcargo.io',
  carriersUrl: 'https://carriers.demo.okcargo.io',

  localVersionsUrl: `${LOCAL_VERSION_URL}`,
  versionsUrl: `${API_URL}/${LOCAL_VERSION_URL}`,

  appNameTagline: 'general.shippers',
  utmSource: 'shippers-app',
  termsUrl: 'https://okcargo.com/condiciones-para-el-cargador/',
  privacyUrl: 'https://okcargo.com/politica-de-privacidad/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
